module.exports = __webpack_public_path__ + "img/icon-profile-program.2f5ac501.svg";